var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1744699513385,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2996,
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 145.066667a281.6 281.6 0 0 1 260.224 389.376 25.6 25.6 0 1 1-47.274666-19.626667 230.4 230.4 0 0 0-301.098667-301.098667 25.6 25.6 0 1 1-19.626667-47.274666A280.832 280.832 0 0 1 597.333333 145.066667z",
    fill: "#8a8a8a",
    "p-id": 2997
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 17.066667a409.6 409.6 0 0 1 378.496 566.4 25.6 25.6 0 1 1-47.274666-19.626667A358.4 358.4 0 0 0 460.16 95.445333a25.6 25.6 0 0 1-19.626667-47.274666A408.448 408.448 0 0 1 597.333333 17.066667zM222.378667 222.378667a409.6 409.6 0 1 0 579.242666 579.242666 25.6 25.6 0 0 0 0-36.181333L258.56 222.378667a25.6 25.6 0 0 0-36.181333 0z m18.730666 54.912l505.514667 505.6A358.4 358.4 0 0 1 241.109333 277.333333z",
    fill: "#8a8a8a",
    "p-id": 2998
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M621.909333 365.909333a25.6 25.6 0 0 1 39.168 32.64l-2.986666 3.541334-128 128a25.6 25.6 0 0 1-39.168-32.64l2.986666-3.541334 128-128zM415.232 873.088a25.6 25.6 0 0 1 32.170667 7.893333l2.133333 3.584 42.666667 85.333334a25.6 25.6 0 0 1-43.605334 26.453333l-2.133333-3.584-42.666667-85.333333a25.6 25.6 0 0 1 11.434667-34.346667z",
    fill: "#8a8a8a",
    "p-id": 2999
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M579.242667 323.242667a25.6 25.6 0 0 1 32.64-2.986667l3.541333 2.986667 85.333333 85.333333a25.6 25.6 0 0 1-32.64 39.168l-3.541333-2.986667-85.333333-85.333333a25.6 25.6 0 0 1 0-36.181333zM597.333333 955.733333a25.6 25.6 0 0 1 4.138667 50.858667L597.333333 1006.933333H42.666667a25.6 25.6 0 0 1-4.138667-50.858666L42.666667 955.733333h554.666666z",
    fill: "#8a8a8a",
    "p-id": 3000
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M146.218667 696.490667a25.6 25.6 0 0 1 49.834666 10.965333l-0.938666 4.053333-85.333334 277.333334a25.6 25.6 0 0 1-49.834666-10.965334l0.938666-4.053333 85.333334-277.333333z",
    fill: "#8a8a8a",
    "p-id": 3001
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvGroup);
export default __webpack_public_path__ + "static/media/AdvGroup.8e9d86e3c1fa26bc6a26e1456dd8dc1c.svg";
export { ForwardRef as ReactComponent };